import { resolveProjectMilestones } from '~/lib/projectMilestones';
import type { ProjectStage } from '~/types/models';

export type ProjectCreationMode = 'blank' | 'workflow' | 'template';

export type ProjectCreationDraft = {
  name: string;
  clientId: string;
  description?: string;
  status?: string;
  dueDate?: string;
  stage?: string;
  tags?: string[];
};

export function canQuickCreateProject(draft: ProjectCreationDraft): boolean {
  return Boolean(draft.name.trim() && draft.clientId.trim());
}

export function buildQuickProjectPayload(draft: ProjectCreationDraft) {
  const stage = String(draft.stage || '').trim();
  const stages: ProjectStage[] = stage
    ? [{ id: `stage-${stage.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`, name: stage, order: 1, requiresClientApproval: false }]
    : resolveProjectMilestones();
  const startingStage = stage || stages[0]?.name;

  return {
    name: draft.name.trim(),
    clientId: draft.clientId.trim(),
    description: String(draft.description || '').trim(),
    status: String(draft.status || 'Planning').trim() || 'Planning',
    dueDate: String(draft.dueDate || '').trim() || undefined,
    stage: startingStage,
    stages,
    portalShared: false,
  };
}

export function normalizeProjectCreationStep(step: number): number {
  return Math.min(5, Math.max(1, Number.isFinite(step) ? Math.round(step) : 1));
}

export function canAdvanceProjectCreation(input: {
  step: number;
  name: string;
  clientId: string;
  mode: ProjectCreationMode;
  workflowId?: string;
  templateId?: string;
}): boolean {
  const step = normalizeProjectCreationStep(input.step);
  if (step === 1) return Boolean(input.name.trim() && input.clientId.trim());
  if (step === 2 && input.mode === 'workflow') return Boolean(input.workflowId?.trim());
  if (step === 2 && input.mode === 'template') return Boolean(input.templateId?.trim());
  return true;
}
